export const ALLOWED_COUNTRIES = ['CA', 'US'];
